/** @format */
import React from 'react';

import { ContentfulAccordion } from '../accordion';
import { StyledContentAccordionGroup } from './accordion-group.styles';
import { ContentfulAccordionGroupProps } from './types';

export const ContentfulAccordionGroup = ({
    accordionsCollection,
}: ContentfulAccordionGroupProps) => {
    const accordions = accordionsCollection.items;

    const hasAccordions = accordions.length > 0;
    if (!hasAccordions) {
        return null;
    }

    return (
        <StyledContentAccordionGroup data-testid="accordion-group">
            {accordions.map((accordion) => (
                <ContentfulAccordion
                    key={accordion.sys.id}
                    id={accordion.sys.id}
                    title={accordion.title}
                    content={accordion.content}
                />
            ))}
        </StyledContentAccordionGroup>
    );
};
